import classes from './Button.module.css.mjs';

const buttonSizeClasses = {
  small: classes.buttonSizeSmall,
  medium: classes.buttonSizeMedium,
  large: classes.buttonSizeLarge
};
const buttonVariantClasses = {
  primary: classes.buttonVariantPrimary,
  secondary: classes.buttonVariantSecondary,
  brand: classes.buttonVariantBrand
};
const buttonIconSizeClasses = {
  small: classes.iconButtonSizeSmall,
  medium: classes.iconButtonSizeMedium,
  large: classes.iconButtonSizeLarge
};
const buttonTypographySize = {
  small: "button-s",
  medium: "button-l",
  large: "button-l"
};

export { buttonIconSizeClasses, buttonSizeClasses, buttonTypographySize, buttonVariantClasses };
